var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.486668 11.5489L3.1833 14.2455C3.50165 14.5077 3.82 14.5077 4.13835 14.2455L6.83498 11.5489C7.09716 11.2305 7.09716 10.9122 6.83498 10.5938C6.51663 10.3317 6.19828 10.3317 5.87993 10.5938L4.33498 12.1388V2.53203C4.29753 2.12004 4.07281 1.89532 3.66083 1.85787C3.24884 1.89532 3.02412 2.12004 2.98667 2.53203V12.1388L1.44172 10.5938C1.12337 10.3317 0.80502 10.3317 0.486668 10.5938C0.224496 10.9122 0.224496 11.2305 0.486668 11.5489ZM8.82936 14.4421H10.1777C10.5897 14.4047 10.8144 14.18 10.8518 13.768C10.8144 13.356 10.5897 13.1313 10.1777 13.0938H8.82936C8.41738 13.1313 8.19266 13.356 8.15521 13.768C8.19266 14.18 8.41738 14.4047 8.82936 14.4421ZM8.82936 10.8466H11.9754C12.3874 10.8092 12.6121 10.5845 12.6496 10.1725C12.6121 9.76049 12.3874 9.53577 11.9754 9.49832H8.82936C8.41738 9.53577 8.19266 9.76049 8.15521 10.1725C8.19266 10.5845 8.41738 10.8092 8.82936 10.8466ZM8.82936 7.25113H13.7732C14.1852 7.21367 14.4099 6.98895 14.4473 6.57697C14.4099 6.16498 14.1852 5.94027 13.7732 5.90281H8.82936C8.41738 5.94027 8.19266 6.16498 8.15521 6.57697C8.19266 6.98895 8.41738 7.21367 8.82936 7.25113ZM8.82936 3.65562H15.5709C15.9829 3.61817 16.2076 3.39345 16.2451 2.98146C16.2076 2.56948 15.9829 2.34476 15.5709 2.30731H8.82936C8.41738 2.34476 8.19266 2.56948 8.15521 2.98146C8.19266 3.39345 8.41738 3.61817 8.82936 3.65562Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.31,
    height: 15,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 15.65)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownList);
export default __webpack_public_path__ + "static/media/arrow-down-list.5f556cb94362eaef9434cdfa4a9297b6.svg";
export { ForwardRef as ReactComponent };